import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "./App";
import { installBrowserSink } from "./lib/log-browser-sink";
import { log } from "./lib/logger";
import "./styles.css";

installBrowserSink();
log.info("app", "client.boot", { path: window.location.pathname });

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
